import React from "react"
import { Grid } from "@mui/material"
import ReportFormHeaderTitle from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Header/Title"
import ReportFormHeaderNumSearches from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Header/NumSearches"


export default function ReportFormHeader() {


	return <Grid container spacing={2}>
		<Grid item xs={10}>
			<ReportFormHeaderTitle/>
		</Grid>
		<Grid item xs={2}>
			<ReportFormHeaderNumSearches/>
		</Grid>
	</Grid>
}